import { atom, selectorFamily } from 'recoil';

import { LocationDictionaryModel, LocationModel } from '@/lib/models/location/types';
import { transformLocation } from '@/lib/transformers/location';
import { RouteLocationInterface } from '@/types';
import { formatRouteLocation } from '@/utils/format';

export const defaultLocations: LocationDictionaryModel = {};

export const locationsState = atom<LocationDictionaryModel>({
  key: 'locationsState',
  default: defaultLocations,
});

export const getLocationByIdState = selectorFamily<RouteLocationInterface, string>({
  key: 'getLocationByIdState',
  get:
    (locationId) =>
    ({ get }) => {
      const locationDictionary = get(locationsState);
      return formatRouteLocation(locationId, locationDictionary);
    },
});

export const getLocationsByIdState = selectorFamily<LocationModel[], string[]>({
  key: 'getLocationsByIdState',
  get:
    (locationIds) =>
    ({ get }) => {
      const locationDictionary = get(locationsState);
      return locationIds
        .map((locationId) => {
          const location = locationDictionary[locationId];
          return transformLocation(locationId, location);
        })
        .filter(Boolean);
    },
});
